// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { Rectangle } from '@shared/commons/Geometry';
import { TerceraChartBaseRenderer } from './TerceraChartBaseRenderer';
import { PolyRect, SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import { DynProperty } from '@shared/commons/DynProperty';
import { LayersEnum } from '../Utils/LayersEnum';
export class TerceraChartHighlightExtendedSessionRenderer extends TerceraChartBaseRenderer {
    constructor(chart) {
        super(chart);
        this.SetClassName('TerceraChartHighlightExtendedSessionRenderer');
    }
    get Visible() {
        return this._Visible && this.chart.ShowAllSessions;
    }
    set Visible(value) {
        this._Visible = value;
    }
    IsNeedDraw(numberOfLayer) {
        return this.assignLayer === numberOfLayer || LayersEnum.Quotes === numberOfLayer;
    }
    Draw(gr, window, windowsContainer, advParams = null) {
        if (!this.Visible)
            return;
        const param = advParams;
        if ((param === null || param === void 0 ? void 0 : param.TerceraChart) == null)
            return;
        const isQuotesLayer = param.layerId === LayersEnum.Quotes;
        if (isQuotesLayer)
            return;
        const cashItemSeries = param.TerceraChart.MainCashItemSeries;
        const clientRect = window.ClientRectangle.copy();
        const screenData = cashItemSeries.ChartScreenData.Storage;
        if (screenData.length <= 0) {
            return;
        }
        gr.save();
        gr.beginPath();
        gr.rect(clientRect.X, clientRect.Y, clientRect.Width, clientRect.Height);
        gr.clip();
        const scX = window.XScale;
        const polyRects = new PolyRect();
        for (let i = screenData.length - 1; i >= 0; i--) {
            if (!screenData[i].IsMainSession) {
                const x = window.PointsConverter.GetScreenXbyTime(screenData[i].Time);
                const left = Math.floor(x);
                const right = Math.floor(x + scX);
                const width = right - left;
                if (width > 0) {
                    polyRects.rects.push(new Rectangle(left, clientRect.Y, width, clientRect.Height));
                }
            }
        }
        gr.DrawPolyRect(this.highlightBrush, polyRects);
        // Reset clip.
        gr.restore();
    }
    ThemeChanged() {
        super.ThemeChanged();
        this.setHighlightColor(ThemeManager.colors.Chart_HighlightExtendedSessionsColor);
    }
    Properties() {
        const properties = super.Properties();
        const SeparatorGroup = '#2#' + Resources.getResource('property.SeparatorGroup.Show');
        const prop = new DynProperty('highlightExtendedSessionsColor', this.highlightExtendedSessionsColor, DynProperty.COLOR, DynProperty.TIME_SCALE_GROUP);
        prop.separatorGroup = SeparatorGroup;
        prop.sortIndex = 3;
        properties.push(prop);
        return properties;
    }
    callBack(properties) {
        super.callBack(properties);
        const dp = DynProperty.getPropertyByName(properties, 'highlightExtendedSessionsColor');
        if (dp != null) {
            if (this.highlightExtendedSessionsColor !== dp.value) {
                this.setHighlightColor(dp.value);
            }
        }
    }
    setHighlightColor(color) {
        this.highlightExtendedSessionsColor = color;
        this.highlightBrush = new SolidBrush(color);
    }
}
